export default "/images/small-dots.png"